import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { UserAvatar } from "../../components/Atoms/Avatar";
import { NoDataAvailableDiv } from "../../components/NoDataAvailableDiv";
import SystemOneModal from "../../components/modal";
import UserSelectModal from "./UserSelectModal"; //Change out for UserToClientMultiPicker. It's weird that the FreeFieldProfile is using a different implementation.
import { routes } from "utilities/routing/generatedRoutes";

interface UserListProps {
  environment: server.dto.Environments
  userToClients: server.dto.UserToClientSmall[]
  onUsersChanged: (newUsers: server.dto.UserToClientSmall[]) => void
  freeFieldProfileId: number
}

const userDetailPage = (environment: server.dto.Environments, userToClientId: number) => {
  if (environment === "internal") {
    return routes.internalUser_Detail(userToClientId).absolute;
  } else {
    return routes.externalUser_Detail(userToClientId).absolute;
  }
}

const UsersLists = ({ userToClients, onUserDelete, environment }: {
  userToClients: server.dto.UserToClientSmall[]
  onUserDelete: (userToClientId: number) => void
  environment: server.dto.Environments
}) => {
  if (userToClients.length === 0) {
    return (<></>);
  }

  return (
    <div className="list-with-gaps line-layout">
      <div className="list-with-gaps-body">
        {userToClients.map(userToClient => (
          <div key={userToClient.userToClientId} className="flex padding-small">
            <div className="margin-right"><UserAvatar user={userToClient.user} size="avatar-30" /></div>
            <div className="grow1 padding"><h4><a href={userDetailPage(environment, userToClient.userToClientId)}>{userToClient.user.fullName}</a></h4></div>
            <div><a onClick={() => { onUserDelete(userToClient.userToClientId); }} className="icon-x red"></a></div>
          </div>
        ))}
      </div>
    </div>
  );
};

const UsersStep = (props: UserListProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  const { userToClients: userToClients } = props;

  const addNewlyAssignedUsers = async (newUserToClients: server.dto.UserToClientSmall[]) => {
    setIsModalOpen(false);
    await window.CoreApi.UserToClient.SetUserToClientFreeFieldProfile({
      userToClientIds: newUserToClients.map(userToClient => userToClient.userToClientId),
      freeFieldProfileId: props.freeFieldProfileId
    });

    props.onUsersChanged([...userToClients, ...newUserToClients]);
  };

  const onUserDelete = async (userToClientId: number) => {
    const dto: server.dto.RemoveFreeFieldProfileForUserInstruction = {
      freeFieldProfileId: props.freeFieldProfileId,
      userToClientId
    };

    await window.CoreApi.FreeFieldProfile.RemoveFreeFieldProfileForUser(dto);

    const userToClients = await window.CoreApi.FreeFieldProfile.ListUserToClientsByProfile(props.freeFieldProfileId);
    if (userToClients.data.hasErrors) {
      return;
    }
    props.onUsersChanged(userToClients.data.data);
  };

  return (
    <>
      <SystemOneModal
        isOpen={isModalOpen}
        handleClose={() => { setIsModalOpen(false); }}
        title={RESX.SoUser.AssignUsers}
        height={800}
        width="small"
      >
        <UserSelectModal
          excludeUserToClientIds={userToClients.map(u => u.userToClientId)}
          environment={props.environment}
          onUsersSelected={addNewlyAssignedUsers}
        />
      </SystemOneModal>
      <div className="margin-top-big margin-bottom-larger">
        <div>
          <Button onClick={(e) => {
            e.preventDefault();
            setIsModalOpen(true);
          }} color="green" style={{ marginRight: 0 }} fluid>
            <Icon name="magnify" />
            {RESX.SoUser.AssignUsers}
          </Button>
        </div>
      </div>

      {userToClients.length === 0 && <NoDataAvailableDiv>{RESX.SoUser.NoUsersHaveBeenAssigned}</NoDataAvailableDiv>}

      <UsersLists userToClients={userToClients} onUserDelete={onUserDelete} environment={props.environment} />
    </>
  );
};

export default UsersStep;
